import { queryBot2 } from 'boot/axios';
import { throttle } from 'quasar';
import NodeField from 'pages/mockup/NodeField';
import NodeView from 'pages/mockup/NodeView';
import { decodeHTML } from 'src/pages/mockup/assistFunc.js';
import TreeNode from './TreeNode';

export default class extends TreeNode {
    constructor () {
        super();

        this.label = 'Новый блок';
        this.type = 'block';
        this.innertype = 'block';
        this.p_headline = null;
        this.fixd = false;
        this.public = false;
        this.about = '';
        this.fields = [];
        this.activeField = null;
        this.views = [];
        this.activeView = null;
        this.activeTab = 'form';
        this.getInnerHTMLResultHeader = throttle(this.pgetInnerHTMLResultHeader, 100);
    }

    pgetInnerHTMLResultHeader () {
        let result = '<section class="portfolio__contents contents"><h3 class="contents__title">Оглавление</h3><div class="contents__row">';
        let resBlock = this.getNext();

        const applyFields = (block) => {
            _.each(this.fields, (f) => {
                const rbf = _.find(block.fields, (item) => item.tag === f.tag);
                f.value = rbf?.value || '';
            });
        };

        while (resBlock?.counting) {
            if (resBlock.visible) {
                applyFields(resBlock);
                result += `<div onclick="document.getElementById('${resBlock.id}').scrollIntoView()">${this.p_getInnerHTML()}</div>`;
            }
            resBlock = resBlock.getNext();
        }
        applyFields({});
        result += '</div></section>';
        return result;
    }

    getInnerHTML (preview) {
        let result = decodeHTML(this.activeView?.content);
        _.each(this.fields, (item) => {
            if (item.tag) {
                // const value = item.tag === 'exmp' && item.value ? `href="${item.value}"` : item.value;
                result = result.replaceAll(`$${item.tag}`, item.value || '');
            }
        });

        _.each(Object.keys(this), (k) => {
            result = result.replaceAll(`$AA${k}`, this[k]);
        });

        let css = '';
        if (preview) {
            const mockup = this.getParentBy('innertype', 'mockup');
            css = mockup?.css?.content;
        }

        result = result.replace('<pre>', '');
        result = result.replace('</pre>', '');
        result = result.replace('<code>', '');
        result = result.replace('</code>', '');
        result = `<div id="${this.id}" class="druid_block">${result}</div> ${css}`;
        return result;
    }

    save () {
        if (this.parent.innertype === 'template') {
            return this.parent.save();
        }
        const saveData = {
            fixd: this.fixd,
            public: this.public,
            visible: true,
            about: this.about,
        };
        saveData.fields = _.map(this.fields, (item, position) => {
            // eslint-disable-next-line
            const { type, label, tag, key, value, hint, } = item;
            return {
                type,
                label,
                tag,
                key,
                value,
                hint,
                position,
            };
        });
        return this.saveData(saveData);
    }

    initData (data) {
        this.data = _.clone(data);
        if (!data) return;

        this.serverId = data.id;
        this.label = data.title;
        this.target = data.target;
        this.description = data.description;
        if (this.serverId === '5') {
            this.p_getInnerHTML = this.getInnerHTML;
            this.getInnerHTML = this.getInnerHTMLResultHeader;
            this.headline = this.label;
        }
        this.fixd = this.dataJSON.fixd;
        this.counting = !this.fixd;
        this.about = this.dataJSON.about;
        this.public = this.dataJSON.public;

        _.each(this.dataJSON.fields, (item) => {
            const f = new NodeField(item.type);
            f.label = item?.label;
            f.tag = item?.tag;
            f.key = item?.key;
            f.value = item?.value || '';
            f.hint = item?.hint;
            f.position = item?.position || 0;
            this.addNode(f, this.fields);
        });
        if (!this.activeField) {
            this.activeField = this.firstChild(this.fields);
        }
    }

    initViews () {
        if (!this.serverId) {
            this.addNode(new NodeView(), this.views);
            this.activeView = this.firstChild(this.views);
            return null;
        }
        return queryBot2('get-block-views', { serverId: this.serverId })
            .then((res) => {
                _.each(res.data, (item) => {
                    const v = new NodeView();
                    v.initData(item);
                    this.addNode(v, this.views);
                });
                if (this.views.length === 0) {
                    this.addNode(new NodeView(), this.views);
                }
                this.activeView = this.firstChild(this.views);
            });
    }

    get headline () {
        return this.p_headline || _.find(this.fields, (item) => item.tag === 'title')?.value;
    }

    set headline (value) {
        this.p_headline = value;
    }
}
